import { render, staticRenderFns } from "./AccordionCustomFieldComponent.vue?vue&type=template&id=10bf17fe"
import script from "./AccordionCustomFieldComponent.vue?vue&type=script&lang=js"
export * from "./AccordionCustomFieldComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports